import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { COST_CENTER_PATH } from "../constants";
import {
  CreateCostCenterDto,
  UpdateCostCenterDto,
} from "../dtos/costCenter.dtos";
import { formatString } from "@/core/utils/helpers";

class CostCenterService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getCostCenters(
    organizationId: string,
    isActive?: boolean,
  ): Promise<ICoreResponse> {
    const basePath = formatString(
      COST_CENTER_PATH.GET_COST_CENTERS,
      organizationId,
    );
    const url =
      typeof isActive === "boolean"
        ? `${basePath}?is_active=${isActive}`
        : basePath;
    return this.restClient.get(url);
  }

  public createCostCenter(
    organizationId: string,
    body: CreateCostCenterDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(COST_CENTER_PATH.CREATE_COST_CENTER, organizationId),
      body,
    );
  }

  public updateCostCenter(
    organizationId: string,
    body: UpdateCostCenterDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(COST_CENTER_PATH.UPDATE_COST_CENTER, organizationId),
      body,
    );
  }

  public patchCostCenterStatus(
    organizationId: string,
    costCenterId: string,
    isActive: boolean,
  ): Promise<ICoreResponse> {
    return this.restClient.patch(
      formatString(
        COST_CENTER_PATH.PATCH_COST_CENTER_STATUS,
        organizationId,
        costCenterId,
      ),
      {
        is_active: isActive,
      },
    );
  }

  public deleteCostCenter(
    organizationId: string,
    publicId: string,
  ): Promise<ICoreResponse> {
    return this.restClient.delete(
      formatString(
        COST_CENTER_PATH.DELETE_COST_CENTER,
        organizationId,
        publicId,
      ),
      "",
    );
  }
}

export default CostCenterService;
